import staffFetch from "./staffFetch";
import React, { useEffect, useState } from "react";

const API = "https://live-evo.com/api";
const MEDIA_BASE = "https://live-evo.com/uploads/";

function StaffReportedVideosPage() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  const getVideoUrl = (path) => {
    if (!path) return "";

    if (path.startsWith("http")) {
      return path;
    }

    return `${MEDIA_BASE}${path}`;
  };

  const loadReports = async () => {
    try {
      setLoading(true);

      const res = await staffFetch(`${API}/admin/reported-videos`);
      const data = await res.json();

      if (data.success) {
        setReports(data.reports || []);
      }
    } catch (err) {
      console.log("Erreur loadReports:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadReports();
  }, []);

  const visibleReports = reports.filter((r) => {
    return String(r.report_status || "").toLowerCase() !== "ferme";
  });

  const action = async (url, body, msg) => {
    try {
      const res = await staffFetch(`${API}/admin/reported-videos/${url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const data = await res.json();

      if (!data.success) {
        alert(data.message || "Action impossible");
        return;
      }

      alert(msg);

      loadReports();
    } catch (err) {
      console.log(err);
      alert("Serveur inaccessible");
    }
  };

  return (
    <div
      style={{
        background: "#000",
        minHeight: "100vh",
        color: "#fff",
        padding: "20px",
      }}
    >
      <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
        <button
          onClick={() => window.history.back()}
          style={{
            background: "transparent",
            border: "none",
            color: "#00f2ff",
            fontWeight: "bold",
            marginBottom: "20px",
            cursor: "pointer",
          }}
        >
          ← Retour Dashboard
        </button>

        <h1
          style={{
            color: "#00f2ff",
            marginBottom: "25px",
          }}
        >
          🎬 Vidéos signalées
        </h1>

        {loading && (
          <div style={{ color: "#888" }}>
            Chargement des signalements...
          </div>
        )}

        {!loading && visibleReports.length === 0 && (
          <div
            style={{
              background: "#050505",
              border: "1px solid #00f2ff",
              borderRadius: "14px",
              padding: "20px",
            }}
          >
            Aucun signalement à traiter.
          </div>
        )}

        {visibleReports.map((r) => {
          const videoUrl = getVideoUrl(r.file_path);

          return (
            <div
              key={r.report_id}
              style={{
                background: "#050505",
                border: "1px solid #00f2ff",
                borderRadius: "16px",
                padding: "18px",
                marginBottom: "25px",
              }}
            >
              {/* ===== HEADER ===== */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: "10px",
                }}
              >
                <div>
                  <div
                    style={{
                      color: "#00f2ff",
                      fontWeight: "bold",
                      marginBottom: "6px",
                    }}
                  >
                    Auteur :
                    {" "}
                    {r.video_owner_pseudo ||
                      r.video_owner_email ||
                      "inconnu"}
                  </div>

                  <div style={{ color: "#bbb", fontSize: "14px" }}>
                    Signalé par :
                    {" "}
                    {r.reporter_pseudo ||
                      r.reporter_email ||
                      "inconnu"}
                  </div>
                </div>

                <div
                  style={{
                    color: "#ffcc00",
                    fontWeight: "bold",
                  }}
                >
                  {(r.report_status || "ouvert").toUpperCase()}
                </div>
              </div>

              {/* ===== INFOS ===== */}
              <div style={{ marginTop: "12px" }}>
                <div style={{ marginBottom: "8px" }}>
                  <strong>Motif :</strong>
                  {" "}
                  {r.reason || "Aucun motif"}
                </div>

                <div style={{ color: "#999" }}>
                  Vidéo #{r.video_id}
                  {" "}
                  —
                  {" "}
                  {r.video_status || "status inconnu"}
                </div>
              </div>

              {/* ===== VIDEO ===== */}
              <div
                style={{
                  marginTop: "18px",
                  borderRadius: "12px",
                  overflow: "hidden",
                  background: "#111",
                }}
              >
                {videoUrl ? (
                  <video
                    src={videoUrl}
                    controls
                    style={{
                      width: "100%",
                      maxHeight: "600px",
                      background: "#000",
                    }}
                  />
                ) : (
                  <div
                    style={{
                      padding: "40px",
                      textAlign: "center",
                      color: "#666",
                    }}
                  >
                    Vidéo introuvable
                  </div>
                )}
              </div>

              {/* ===== LIEN DIRECT ===== */}
              <div style={{ marginTop: "15px" }}>
                <a
                  href={videoUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    color: "#00f2ff",
                    textDecoration: "none",
                    fontWeight: "bold",
                  }}
                >
                  🔗 Ouvrir le lien direct vidéo
                </a>
              </div>

              {/* ===== ACTIONS ===== */}
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "10px",
                  marginTop: "20px",
                }}
              >
                <button
                  onClick={() =>
                    action(
                      "hide-video",
                      { video_id: r.video_id },
                      "Vidéo masquée"
                    )
                  }
                  style={btnStyle}
                >
                  Masquer
                </button>

                <button
                  onClick={() =>
                    action(
                      "restore-video",
                      { video_id: r.video_id },
                      "Vidéo restaurée"
                    )
                  }
                  style={btnStyle}
                >
                  Restaurer
                </button>

                <button
                  onClick={() =>
                    action(
                      "delete-video",
                      { video_id: r.video_id },
                      "Vidéo supprimée"
                    )
                  }
                  style={deleteBtnStyle}
                >
                  Supprimer
                </button>

                <button
                  onClick={() =>
                    action(
                      "resolve",
                      {
                        report_id: r.report_id,
                        admin_response:
                          "Signalement traité par le staff",
                      },
                      "Signalement traité"
                    )
                  }
                  style={resolveBtnStyle}
                >
                  Traiter
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

const btnStyle = {
  background: "transparent",
  border: "1px solid #00f2ff",
  color: "#00f2ff",
  borderRadius: "10px",
  padding: "10px 14px",
  cursor: "pointer",
  fontWeight: "bold",
};

const deleteBtnStyle = {
  background: "transparent",
  border: "1px solid #ff3b30",
  color: "#ff3b30",
  borderRadius: "10px",
  padding: "10px 14px",
  cursor: "pointer",
  fontWeight: "bold",
};

const resolveBtnStyle = {
  background: "#00f2ff",
  border: "none",
  color: "#000",
  borderRadius: "10px",
  padding: "10px 14px",
  cursor: "pointer",
  fontWeight: "bold",
};

export default StaffReportedVideosPage;
